import { styled } from '@mui/material/styles';
import Tab, { TabProps } from '@mui/material/Tab'
import SidebarLink from './SidebarLink';
import { SIDEBAR_BUTTON_HEIGHT, SIDEBAR_PADDING } from './styles';

const SidebarTab = styled(Tab)<TabProps<typeof SidebarLink>>(({ theme }) => ({
  fontWeight: 400,
  fontSize: 18,
  color: theme.palette.text.secondary,
  '&:hover': {
    color: theme.palette.action.active,
  },
  '&.Mui-selected': {
    color: theme.palette.primary.main,
  },
  paddingLeft: `${SIDEBAR_PADDING}px`,
  paddingRight: `${SIDEBAR_PADDING}px`,
  height: SIDEBAR_BUTTON_HEIGHT,
  flexDirection: 'row',
  justifyContent: 'stretch',
  minHeight: 0,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
}))

export default SidebarTab
